import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(event) {
    Array.from(this.element.elements).forEach((el) => {
      if (
        el.name &&
        !el.value &&
        el.type !== "checkbox" &&
        el.type !== "radio" &&
        !this.shouldPreserveField(el)
      ) {
        el.removeAttribute("name")
      }
    })
  }

  shouldPreserveField(element) {
    // Preserve name_cont fields (common search field across all forms)
    if (element.name.endsWith('[name_cont]')) {
      return true;
    }

    // Preserve fields with data-preserve-empty attribute
    // Usage: <input data-preserve-empty ... >
    if (element.dataset.preserveEmpty !== undefined) {
      return true;
    }

    return false;
  }
}